import Header from 'components/home/Header';
import React, { useEffect, useState } from 'react'
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, PointElement, LineElement, Filler } from "chart.js";
import { Bar, Line } from "react-chartjs-2";
import ParceirosApi from 'services/robinhood/ParceirosApi';
import ChartColors from 'components/ChartColors';
import { useLocation } from 'react-router-dom';

export default function Parceiros() {
  const location = useLocation();
  const [parceiros, setParceiros] = useState([]);
  const [target, setTarget] = useState(null);

  useEffect(() => {
    document.getElementById('toggle-menu').className = 'theme-blush';
    new ParceirosApi().parcerias().then(response => {
      setParceiros(response);
    });
    scrollWindow();
  }, []);

  useEffect(() => {
    setTarget(location.state && location.state.parceiro ? location.state.parceiro.id : null);
    if (location.state) {
      handleScrool(location.state.parceiro.id);

    }
  }, [location.state]);

  const scrollWindow = () => {
    let mybutton = document.getElementById("buttomScrollUp");
    window.onscroll = function () { scrollFunction() };
    function scrollFunction() {
      if (document.documentElement.scrollTop > 60) {
        mybutton.style.display = "block";
      } else {
        mybutton.style.display = "none";
      }
    }
  }

  const topFunction = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  const handleScrool = (_element) => {
    const element = document.getElementById(_element);
    if (!element)
      return;

    window.scrollTo({
      behavior: 'smooth',
      top: window.scrollX + element.getBoundingClientRect().top - 100 + window.scrollY
    },);
  }

  const options = {
    responsive: true,
    elements: {
      line: {
        tension: 0.3
      }
    },
    plugins: {
      legend: false,
      title: {
        display: false,

      },
    },
    scales: {
      x: {
        grid: {
          display: false
        }
      },
      y: {
        grid: {
          display: false
        }
      }
    }
  };

  const data = {
    labels: ['a', 'b', 'c'],
    datasets: [
      {
        label: 'label',
        data: [11, 122, 2],
        borderColor: ChartColors,
        backgroundColor: ChartColors,
      }
    ],
  };

  const handleIndicadorCollapse = (_parceiro_id) => {
    const element = document.getElementById(`indicadores-${_parceiro_id}`);
    element.style.display = element.style.display == 'none' ? '' : 'none';
  }

  return (
    <>
      <Header>
        <h5 style={{ marginLeft: '10px', marginBottom: '-40px' }}> <i className='zmdi zmdi-accounts'></i> PARCEIROS  </h5>
      </Header>
      <section className='content' style={{ marginBottom: '-60px' }}>
        <div className='content-fluid m-l-15'>
          <div className='row'>
            <div className="col-lg-4 col-sm-6 col-md-6 col-xs-12 p-1 m-l-10">
              <div className="card bg-blue-grey">
                <a className='small text-white' style={{ textDecoration: 'none', color: 'white', cursor: 'default' }}>
                  <div className="body">
                    <h4 style={{ textTransform: 'uppercase', color: 'white', paddingBottom: '0px', marginBottom: '0px' }}>  <i className='zmdi zmdi-border-all' style={{ fontSize: '30px' }}></i>  ENTIDADES ENVOLVIDAS </h4>
                    <span style={{ color: 'white' }} className=''> {parceiros.length} ENTIDADES ENVOLVIDAS COM AS FONTES DE DADOS  </span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {parceiros && parceiros.length > 0
        ?
        parceiros.map(parceiro =>
          <section className="content">
            <div className="conteiner-fluid">
              <div className="clearfix">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="card">
                    <div className="body">
                      <div className="col-md-12">
                        <h6 className="text-black" key={Math.random()} id={parceiro.id}> <i className='zmdi zmdi-accounts'></i>  {parceiro.parceiro} <strong></strong></h6>
                        <hr />
                      </div>
                      <div className="col-md-12 text-muted text-uppercase">
                        <strong className='text-black' style={{ color: 'black' }}>{parceiro.parceiro_nome}</strong>
                        <span className='m-l-100 text-uppercase small right'> {parceiro.parceiro_descricao} </span> <br />
                        <address className='text-uppercase'>
                          ENDEREÇO: {parceiro.endereco} - CEP {parceiro.cep} <br />
                          {parceiro.cidade} - {parceiro.uf} <br />
                          TELEFONE: {parceiro.telefone} <br />
                          WEBSITE: <span className='text-lowercase' > <a href={parceiro.website} target='_blank' className='text-black-50'>{parceiro.website} </a> </span>
                        </address>
                      </div>
                      {parceiro.contatos.length > 0 &&
                        < div className="col-md-12 text-muted">
                          <br />
                          <p>
                            <strong><i className="zmdi zmdi-account"></i> CONTATOS</strong>
                          </p>
                          <div className="table-responsive">
                            <table id="mainTable" className="table table-striped table-condensed table-sm small">
                              <thead className='text-muted'>
                                <tr>
                                  <th>SETOR</th>
                                  <th>CONTATO</th>
                                  <th>CARGO</th>
                                  <th>TELEFONE</th>
                                  <th>EMAIL</th>
                                </tr>
                              </thead>
                              <tbody className='text-muted'>
                                {parceiro.contatos.map(contato =>
                                  <tr key={Math.random()}>
                                    <td className='text-uppercase'> {contato.setor} </td>
                                    <td className='text-uppercase'> {contato.contato}</td>
                                    <td className='text-uppercase'>{contato.cargo}</td>
                                    <td className='text-uppercase'>
                                      <a className='text-decoration-none text-muted' href={`tel:+55${contato.telefone}`}> {contato.telefone}</a>
                                    </td>
                                    <td className='text-lowercase'>  <a href={`mailto:${contato.email}`} className='text-decoration-none text-muted'> {contato.email} </a></td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      }

                      {parceiro.indicadores.length > 0 &&
                        <div className="col-md-12 text-muted">
                          <br />
                          <hr />
                          <p>
                            <strong>
                              <a onClick={() => handleIndicadorCollapse(parceiro.id)} className='text-black-50' style={{ cursor: 'pointer' }} >
                                <i className="zmdi zmdi-chart"></i> ENTIDADE ENVOLVIDA NOS SEGUINTES ÍNDICES  <i className='zmdi zmdi-caret-down m-l-10'></i>
                                <span className='badge badge-pill right  '>{parceiro.indicadores.length} {parceiro.indicadores.length > 1 ? 'ÍNDICES' : 'ÍNDICE'}  </span>
                              </a>
                            </strong>

                          </p>
                          <div className='' style={{ transition: 'all', animation: 'infinite' }}>
                            <table className='table table-striped table-condensed table-sm small' id={`indicadores-${parceiro.id}`} style={{ display: 'none' }}>
                              <thead className='text-muted'>
                                <th>INDICADOR  </th>
                                <th>DESCRIÇÃO  </th>
                                <th>CATEGORIA  </th>
                                <th>UNIDADE  </th>
                                <th>PERIODICIDADE </th>
                              </thead>
                              <tbody>
                                {parceiro.indicadores.map(indicador =>
                                  <tr className='text-muted'>
                                    <td>{indicador.nome}</td>
                                    <td> {indicador.descricao}</td>
                                    <td>{indicador.categoria}</td>
                                    <td>{indicador.unidade}</td>
                                    <td>{indicador.periodicidade}</td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                          <br />
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div >
            </div >
          </section >)
        : null
      }
      <a onClick={topFunction} id="buttomScrollUp" className='btn btn-rouded  waves-effect'>
        <i className='zmdi zmdi-caret-up-circle' style={{ marginTop: '0px', paddingTop: '-10px' }}></i>
      </a>
    </>);
}
